/*
    Cart template component
*/

import { app } from '../app.js';

import QuantityField from './quantity-field.vue'

export default {
    components: {
        QuantityField
    },

    computed: {
        // We need to pass through the vars here for reasons 
        // I can't remember, but if these get removed it falls apart
        cart() {
            return app.cart;
        },
        cartProducts() {
            return app.cartProducts;
        },
        isCartLoading() {
            return app.isCartLoading;
        },
        cartMessage() {
            return app.cartMessage;
        }
    },
    methods: {
        filterLineItemProperties(data) {
            return app.filterLineItemProperties(data);
        },
        filterLineItemPrices(data) {
            return app.filterLineItemPrices(data);
        },
        addProduct(item) {
            return app.addProduct(item);
        },
        removeProduct(item, quantity) {
            return app.removeProduct(item, quantity);
        },
        findItemDiscountMessage(item) {
            return app.findItemDiscountMessage(item);
        },
        handelUpdateQuantity(item, quantity) {
            return app.updateQuantity(item, quantity)
        }
    }
}